@if (detail?.data?.antifraud?.FACIAL_RECOGNITION) {
    <app-item-check-facial-recognition
        [detail]="$any(detail?.data)"
        [birthdate]="detail?.identity?.birthdate"
        [polImages]="detail?.data?.images"
        [ocrImages]="detail?.data?.images"
    />
}
